// Mirrors BOOST_PRODUCT_ID in ioi_sys_subscription.py - no shared constant exists across languages.
export const BOOST_PRODUCT_ID = "erp-boost"